<template>
  <div class="shipping-dropdown">
    <select
      v-model="dropdownIndex"
      class="shipping-dropdown__select"
      :class="{
        [$class('disabled')]: dropdownIndex === -1,
      }"
    >
      <option
        :value="-1"
        v-text="$string('product.shipping.choose_country')"
      />

      <template
        v-for="(option, optionIndex) of dropdownData"
        :key="optionIndex"
      >
        <option
          :selected="optionIndex === dropdownIndex"
          :value="optionIndex"
          v-text="option.country"
        />
      </template>
    </select>

    <div
      v-if="selectedDropdown"
      class="shipping-dropdown__content rte"
    >
      <div
        v-if="selectedDropdown.additionalMessage"
        class="shipping-dropdown__additional-message"
        v-html="selectedDropdown.additionalMessage"
      />

      <div
        v-if="selectedDropdown.charge"
        class="shipping-dropdown__delivery-information"
      >
        <span
          v-if="selectedDropdown.heading"
          class="shipping-dropdown__heading"
          v-html="selectedDropdown.heading"
        />

        <span
          v-if="selectedDropdown.eta"
          class="shipping-dropdown__eta"
          v-html="$string(
            'product.shipping.eta',
            {
              replace: { eta: selectedDropdown.eta },
            }
          )"
        />

        <span
          v-if="selectedDropdown.charge"
          class="shipping-dropdown__charge"
          v-html="$string(
            'product.shipping.charge',
            {
              replace: { charge: selectedDropdown.charge },
            }
          )"
        />

        <span
          v-if="taxText"
          class="shipping-dropdown__tax"
          v-html="taxText"
        />

        <span
          v-if="selectedDropdown.courier"
          class="shipping-dropdown__courier"
          v-html="$string(
            'product.shipping.courier',
            {
              replace: { courier: selectedDropdown.courier },
            }
          )"
        />
      </div>

      <div
        v-if="selectedDropdown.notes"
        class="shipping-dropdown__notes"
        v-html="selectedDropdown.notes"
      />
    </div>

    <div
      v-if="showIdMessage"
      class="shipping-dropdown__id-message"
      v-html="selectedDropdown.idMessage"
    />
  </div>
</template>

<script>

/**
 * Vue: Shipping Dropdown (shipping-dropdown)
 * -----------------------------------------------------------------------------
 * Dropdown component containing shipping information by country
 *
 * @param {Array} dropdownData - Array of objects to be shown in dropdown.
 */

export default {
  name: 'ShippingDropdown',

  props: {
    dropdownData: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      accordions: [],
      dropdownIndex: -1,
      selectedDropdown: null,
    }
  },

  computed: {

    /**
     * Compute whether to show ID message
     * @returns {Boolean}
     */
    showIdMessage() {
      if (!this.selectedDropdown?.idMessage) {
        return false
      }

      switch (this.selectedDropdown.country) {
        case 'United States':
        case 'Russia':
        case 'Canada':
        case 'Spain':
        case 'United Kingdom':
          return false
        default:
          return true
      }
    },

    /**
     * Compute shipping information tax
     * @returns {Boolean | String}
     */
    taxText() {
      const tax = this.selectedDropdown?.tax

      if (!tax || tax.match(/none/i)) {
        return false
      }

      if (this.selectedDropdown.tax.match(/Delivered Duties Paid/i)) {
        return this.$string('product.shipping.tax.delivered_duties')
      }

      return this.$string('product.shipping.tax.default')
    },
  },

  watch: {

    /**
     * Watch dropdownIndex value to update selected dropdown.
     */
    dropdownIndex() {
      this.selectedDropdown = this.dropdownData[this.dropdownIndex]
    },
  },
}
</script>

<style lang="scss">
@import './shipping-dropdown';
</style>
